export default "__VITE_ASSET__BHi0nDCp__"